import { colors } from '@utils/constants';
import { IEvolution } from '@utils/models/LeadEventsAndTaskList';

export function addColorsEvaluation(data: IEvolution) {
  const evRatio = data?.value / data?.maxValue;
  let evBgColor = '';

  if (evRatio < 0.5) {
    evBgColor = colors.error[200] as string;
  } else if (evRatio < 0.8) {
    evBgColor = colors.warning[200] as string;
  } else {
    evBgColor = colors.success[200] as string;
  }

  const updatedData = data?.templatePart?.criteria?.map(item => {
    const ratio = item.value / item.valuation;
    let color = '';
    let bgColor = '';

    if (ratio < 0.5) {
      color = colors.error[600] as string;
      bgColor = colors.error[200] as string;
    } else if (ratio < 0.8) {
      color = colors.warning[600] as string;
      bgColor = colors.warning[200] as string;
    } else {
      color = colors.success[600] as string;
      bgColor = colors.success[200] as string;
    }

    return {
      ...item,
      bgColor,
      color
    };
  });

  return {
    ...data,
    evBgColor,
    templatePart: {
      ...data?.templatePart,
      criteria: updatedData
    }
  };
}
